import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from './style.css'
import isEqual from 'lodash/isEqual'
import preventSelectConflicts from '../prevent-select-conflicts'
import resetHiddenComponent from '../reset-hidden-components'

class SelectItem extends Component {
  shouldComponentUpdate (nextProps) {
    return !isEqual(nextProps.options, this.props.options) || !isEqual(nextProps.value, this.props.value)
  }

  setValue (val) {
    if (val === this.props.value) {
      return
    }

    if (this.props.onChange) {
      this.props.onChange(val)
    }
  }

  render () {
    const classNames = [
      css.container,
      this.props.sm ? css.sm : ''
    ]

    let optionClassNames

    return (
      <div>
        {this.props.label && <h4 id={this.props.labelId}>{this.props.label}</h4>}
        <div className={classNames.join(' ')} id={this.props.id || ''}>
          {this.props.options.map((option, i) => {
            optionClassNames = [
              css.option,
              this.props.value === option.value ? css.active : '',
              option.disabled ? css.disabled : ''
            ]
            return (
              <div id={`${this.props.id}-${option.value}`} key={i} onClick={option.disabled ? null : this.setValue.bind(this, option.value)} className={optionClassNames.join(' ')}>
                {option.label}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

SelectItem.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool
      ]),
      label: PropTypes.string,
      disabled: PropTypes.bool
    })
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  initVal: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),
  onChange: PropTypes.func.isRequired
}

export default resetHiddenComponent(preventSelectConflicts(SelectItem))



// WEBPACK FOOTER //
// ./src/components/select-item/index.js